module.exports = __webpack_public_path__ + "static/img/公司2.78812d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/image/公司2.jpg
// module id = 786S
// module chunks = 1